export const OPEN_IMAGE_MODAL = "OPEN_IMAGE_MODAL";
export const CLOSE_IMAGE_MODAL = "CLOSE_IMAGE_MODAL";



// WEBPACK FOOTER //
// ./src/constants/imageModal.js